<template>
    <v-container fluid>
        <v-card>
            <v-card-text>
                <PhotosList
                    :experiment="experiment"
                    :protocol="protocol"
                    :task-schedule="taskSchedule"
                />
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import PhotosList from "@/components/Photos/PhotosList.vue";

export default {
    components: { PhotosList },
    props: {
        experiment: {
            type: Object,
            required: true,
        },
        protocol: {
            type: Object,
            required: true,
        },
        taskSchedule: {
            type: Object,
            required: true,
        },
    },
};
</script>
